module.exports = __webpack_public_path__ + "8dd5e7866d0c6cabc03b98ba0e0b5506.svg";